import { ReactNode } from 'react';
import { AiFillInfoCircle } from 'react-icons/ai';
import Tooltip from './Tooltip';

type Props = {
    title?: ReactNode;
    position?: 'top' | 'bottom' | 'left' | 'right';
    className?: string;
};

export default function InfoTooltip({ title, position, className = 'ml-2' }: Props) {
    if (!title) return null;

    return (
        <Tooltip position={position} title={title}>
            <AiFillInfoCircle className={className} />
        </Tooltip>
    );
}
